var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('button',{staticClass:"box-button-scroll-to-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-top"})])])}
var staticRenderFns = []

export { render, staticRenderFns }